document.addEventListener('DOMContentLoaded', () => {
  const progressPath = document.querySelector('.button__back-to-top .progress-circle path');
  if (!progressPath) return;

  const pathLength = progressPath.getTotalLength();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
  progressPath.style.strokeDashoffset = pathLength;

  let lastProgress = null;
  let scheduled = false;

  function updateProgress() {
    scheduled = false;
    const height = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const progress = pathLength - ((window.scrollY || window.pageYOffset) * pathLength) / height;

    if (progress !== lastProgress) {
      progressPath.style.strokeDashoffset = progress;
      lastProgress = progress;
    }
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateProgress);
  }

  scheduleUpdate();
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
});
